// extracted by mini-css-extract-plugin
export default {"container":"bC-z","dimension":"cC-z","dimensionLabels":"dC-z"};